import { ReactElement, ReactNode } from 'react'
import { Copy, Eye } from 'iconoir-react'
import { PageScroll } from 'app/components/layout/PageScroll'
import { Button } from 'app/components/ui/button'
import { PageHeaderComponent } from 'app/components/page-header/PageHeaderComponent'
import { Toggle } from 'app/components/ui/toggle'
import type { TabType } from 'app/components/ui/nav-tabs'

export type SchedulingLocationViewComponentProps = {
  locationName: string
  isSchedulerLive?: boolean
  tabs: TabType[] | undefined
  onToggleSchedulerLive: (value: boolean) => Promise<boolean>
  onCopyPreviewLink: () => void
  onCopySchedulingLink: () => void
  children?: ReactNode
}

export function SchedulingLocationViewComponent({
  locationName,
  isSchedulerLive,
  tabs,
  onToggleSchedulerLive,
  onCopyPreviewLink,
  onCopySchedulingLink,
  children,
}: SchedulingLocationViewComponentProps): ReactElement {
  return (
    <PageScroll
      contentClassName="mt-2 flex flex-col pb-9"
      header={
        <PageHeaderComponent
          title={locationName}
          tabs={tabs}
          primaryButtonSlot={
            <Toggle
              defaultValue={isSchedulerLive}
              label="Scheduler Live"
              controlled
              handleToggle={onToggleSchedulerLive}
              labelClassName="text-strong text-body-sm"
            />
          }
          secondaryButtonSlot={
            <div className="flex items-center gap-1">
              <Button variant="tertiary" size="sm" onClick={onCopyPreviewLink}>
                <Eye /> Copy preview link
              </Button>
              <Button variant="tertiary" size="sm" onClick={onCopySchedulingLink}>
                <Copy /> Copy scheduling link
              </Button>
            </div>
          }
        />
      }
    >
      {children}
    </PageScroll>
  )
}
